import { ItemCardWithAvatar } from 'shared/components';

import makeClasses from './ItemInfoCardWithAvatar.style';

import type { ItemCardWithAvatarProps } from 'shared/components';

export function ItemInfoCardWithAvatar(props: Props) {
  const { title, info } = props;

  const _classes = makeClasses();

  return (
    <section className={_classes.baseSections}>
      {Boolean(title) && <h3 className={_classes.subTitle}>{title}</h3>}
      <ItemCardWithAvatar
        title={info.title}
        imageUrl={info.imageUrl}
        description={info.description}
      />
    </section>
  );
}

interface Props {
  title?: string;
  info: ItemCardWithAvatarProps;
}
